import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-dstack",
  "use": "oc-dstack-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-dstack\"><path d=\"M699.574857 219.428571h55.296c61.074286 0 110.628571 49.115429 110.628572 109.714286v585.142857c0 60.598857-49.517714 109.714286-110.628572 109.714286H349.257143v-164.571429h184.356571c91.648 0 165.961143-73.691429 165.961143-164.571428V219.428571zM128 0h405.613714c61.110857 0 110.628571 49.115429 110.628572 109.714286v585.142857c0 60.598857-49.517714 109.714286-110.628572 109.714286H128V0z\" p-id=\"2430\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol